import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import Basket from './components/Basket';
export default function () {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    items.add('catchthefish-basket', m(Basket));
  });
}